<template>
  <div class="empty-state">
    <span class="empty-state__text">{{
      $t("message.facebook.noConnectedFacebookAccount")
    }}</span>
  </div>
</template>

<script>
export default {
  name: "FacebookAccountsEmptyState"
};
</script>
<style lang="scss" scoped>
.empty-state {
  border-radius: 16px;
  border: 1px dashed $gray-700;
  display: flex;
  padding: 24px;
  align-items: center;
  gap: 24px;
  justify-content: space-between;

  &__text {
    @include font-size(14px);
    font-weight: 700;
  }
}
</style>
